import type { TokenizerExtension } from 'marked';
import { HEX_COLOR_TOKEN_NAME, type HexColorToken } from './color-types';

const HEX_COLOR_PATTERN = /^#(?:[0-9A-Fa-f]{8}|[0-9A-Fa-f]{6})(?![0-9A-Za-z_])/;
const WORD_CHARACTER_PATTERN = /[0-9A-Za-z_]/;
const MARKED_INLINE_TOKEN_LEVEL = 'inline';

function hasStandaloneLeadingBoundary(input: string, index: number): boolean {
  if (index === 0) {
    return true;
  }

  return !WORD_CHARACTER_PATTERN.test(input[index - 1] ?? '');
}

function findFirstHexColor(input: string): number | undefined {
  for (let index = input.indexOf('#'); index >= 0; index = input.indexOf('#', index + 1)) {
    if (!hasStandaloneLeadingBoundary(input, index)) {
      continue;
    }

    if (HEX_COLOR_PATTERN.test(input.slice(index))) {
      return index;
    }
  }

  return undefined;
}

export function createHexColorTokenizerExtension(): TokenizerExtension {
  return {
    name: HEX_COLOR_TOKEN_NAME,
    level: MARKED_INLINE_TOKEN_LEVEL,
    start(src) {
      return findFirstHexColor(src);
    },
    tokenizer(src) {
      const match = HEX_COLOR_PATTERN.exec(src);
      if (!match) {
        return undefined;
      }

      const hex = match[0];
      const token: HexColorToken = {
        type: HEX_COLOR_TOKEN_NAME,
        raw: hex,
        text: hex,
        hex,
      };

      return token;
    },
  };
}
